export default {"src":"/_next/static/media/crown-solid.864e271c.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};